import { gsap, ScrollTrigger } from '../global/gsap';

const initCultureCta = (el) => {
    const hero = document.querySelector('.hero-text');
    const footer = document.querySelector('.footer');

    const toggleButton = (show) => {
        el.classList.toggle('is-active', show);
    };

    if (footer && hero && el) {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: hero,
                endTrigger: footer,
                start: 'bottom top',
                end: 'top bottom',
                onEnter: () => {
                    toggleButton(true);
                },
                onLeave: () => {
                    toggleButton(false);
                },
                onLeaveBack: () => {
                    toggleButton(false);
                },
                onEnterBack: () => {
                    toggleButton(true);
                }
            },
        });
    } else {
        toggleButton(true);
    }
};

export default initCultureCta;
